// extracted by mini-css-extract-plugin
module.exports = {"innerMargin":"OwnerSingleLoginApp_innerMargin__1oq3S"};